import React from 'react';
import { useParams } from 'react-router-dom';

import RegionDetailsContainer from '@totem/components/portfolio/regions/details/RegionDetailsContainer';
import RegionDetailsLayout from '@totem/components/portfolio/regions/details/RegionDetailsLayout';
import RegionDetailsPageTitle from '@totem/components/portfolio/regions/details/RegionDetailsPageTitle';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const RegionDetailsPage = () => {
  const { id } = useParams();

  return (
    <RegionDetailsContainer id={id}>
      <ContentLayout pageTitle={<RegionDetailsPageTitle />}>
        <RegionDetailsLayout />
      </ContentLayout>
    </RegionDetailsContainer>
  );
};

export default RegionDetailsPage;
